import { render } from "./slideShowNavigation.vue?vue&type=template&id=154a05da"
import script from "./slideShowNavigation.vue?vue&type=script&lang=js"
export * from "./slideShowNavigation.vue?vue&type=script&lang=js"

import "./slideShowNavigation.vue?vue&type=style&index=0&id=154a05da&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__